import FormularioIngresos from "components/ingresos/FormularioIngresos";
import Navbar from "components/generales/Navbar";
import React from "react";
import "components/generales/Styles.css";
import "components/ingresos/StylesIngresos.css";

const RegistrarIngresos = ({ ingreso }) => {
  return (
    <>
      <Navbar />
      <section>
        <div className="imagenContenedor imagenIngresos"></div>
        <div className="contenidoContenedor">
          <div className="formularioContenedor">
            <h2>{ingreso?.nombre ? "Editar Gasto" : "Registrar Ingreso"}</h2>
            <FormularioIngresos ingreso={ingreso} />
          </div>
        </div>
      </section>
    </>
  );
};

export default RegistrarIngresos;
